export default __webpack_public_path__ + "static/media/Home1.ca79e35d.png";